import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import NotesPanel from '../../Panel/Notes';
import { NOTEABLE_TYPES } from '../../../../lib/constants';
import styles from './CollectionDetailNotes.module.scss';

const CollectionDetailNotes = (props) => {
  return (
    <div className={styles.notesContainer}>
      <NotesPanel
        isOwner={props.selectedCollection.isOwner}
        noteableType={NOTEABLE_TYPES.Collection}
        noteableId={props.selectedCollection.uuid}
      />
    </div>
  );
};

CollectionDetailNotes.propTypes = {
  selectedCollection: PropTypes.object
};

export default connect((model) => ({
  selectedCollection: model.collections.selectedCollection
}))(CollectionDetailNotes);
